import { IdValue } from '../../../shared/models/id-value.model';

export enum MaritalStatusEnum {
  NotAssigned = 0,
  Married = 1,
  Separated = 2,
  Unmarried = 3,
}

export const maritalStatusTypes: IdValue[] = [
  new IdValue(MaritalStatusEnum.NotAssigned, 'NotAssigned', 'Select'),
  new IdValue(MaritalStatusEnum.Married, 'Married', 'Married'),
  new IdValue(MaritalStatusEnum.Unmarried, 'Unmarried', 'Unmarried'),
  new IdValue(MaritalStatusEnum.Separated, 'Separated', 'Separated'),
];

export enum CitizenResidencyEnum {
  Select = 0,
  US_Citizen = 1,
  PermanentResidentAlien = 2,
  NonPermanentResidentAlien = 3,
  NonResidentAlien = 4,
  Unknown = 5,
}

export const citizenResidencyTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'UsCitizen', 'US Citizen'),
  new IdValue(2, 'PermanentResidentAlien', 'Permanent Resident Alien'),
  new IdValue(3, 'NonPermanentResidentAlien', 'Non-Permanent Resident Alien'),
  new IdValue(4, 'NonResidentAlien', 'Non-Resident Alien'),
  new IdValue(5, 'Unknown', 'Unknown'),
];

export const livingStatusTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'Own', 'Own'),
  new IdValue(2, 'Rent', 'Rent'),
  new IdValue(3, 'LivingRentFree', 'Living Rent Free'),
];

export const domesticRelationshipOptions: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'Yes', 'YES'),
  new IdValue(2, 'No', 'NO'),
];

export enum DomesticRelationshipTypeEnum {
  NotAssigned = 0,
  CivilUnion = 1,
  DomesticPartnership = 2,
  RegisteredReciprocalBeneficiaryRelationship = 3,
  Other = 4,
}

export const domesticRelationshipTypes: IdValue[] = [
  new IdValue(DomesticRelationshipTypeEnum.NotAssigned, 'NotAssigned', 'Select'),
  new IdValue(DomesticRelationshipTypeEnum.CivilUnion, 'CivilUnion', 'Civil Union'),
  new IdValue(DomesticRelationshipTypeEnum.DomesticPartnership, 'DomesticPartnership', 'Domestic Partnership'),
  new IdValue(
    DomesticRelationshipTypeEnum.RegisteredReciprocalBeneficiaryRelationship,
    'RegisteredReciprocalBeneficiaryRelationship',
    'Registered Reciprocal Beneficiary Relationship',
  ),
  new IdValue(DomesticRelationshipTypeEnum.Other, 'Other', 'Other'),
];
